<template>
    <div class="base-info">
        <table class="field-table" border v-if="info">
            <tr>
                <td class="title">企业经营状态</td>
                <td v-if="info.info">{{ info.info.企业经营状态 }}</td>
                <td class="title">法定代表人</td>
                <td v-if="info.info">{{ info.info.法定代表人 }}</td>
            </tr>
            <tr>
                <td class="title">注册资本</td>
                <td v-if="info.info">{{ info.info.注册资本 }}</td>
                <td class="title">成立日期</td>
                <td v-if="info.info">{{ info.info.成立日期 }}</td>
            </tr>
            <tr>
                <td class="title">实缴资本</td>
                <td v-if="info.info">{{ info.info.实缴资本 }}</td>
                <td class="title">是否小微企业</td>
                <td v-if="info.info">{{ info.info.是否小微企业 }}</td>
            </tr>
            <tr>
                <td class="title">统一社会信用代码</td>
                <td v-if="info.info">{{ info.info.统一社会信用代码 }}</td>
                <td class="title">企业地址</td>
                <td v-if="info.info">{{ info.info.企业地址 }}</td>
            </tr>
            <tr>
                <td class="title">所属省份</td>
                <td v-if="info.info">{{ info.info.所属省份 }}</td>
                <td class="title">所属城市</td>
                <td v-if="info.info">{{ info.info.所属城市 }}</td>
            </tr>
            <tr>
                <td class="title">所属区县</td>
                <td v-if="info.info">{{ info.info.所属区县 }}</td>
                <td class="title">邮箱</td>
                <td v-if="info.info">{{ info.info.邮箱 }}</td>
            </tr>
            <tr>
                <td class="title">登记机关</td>
                <td v-if="info.info">{{ info.info.登记机关 }}</td>
                <td class="title">登记状态</td>
                <td v-if="info.info">{{ info.info.登记状态 }}</td>
            </tr>
            <tr>
                <td class="title">企业机构类型</td>
                <td v-if="info.info">{{ info.info['企业（机构）类型'] }}</td>
                <td class="title">纳税人识别号</td>
                <td v-if="info.info">{{ info.info.纳税人识别号 }}</td>
            </tr>
            <tr>
                <td class="title">注册号</td>
                <td v-if="info.info">{{ info.info.注册号 }}</td>
                <td class="title">组织机构代码</td>
                <td v-if="info.info">{{ info.info.组织机构代码 }}</td>
            </tr>
            <tr>
                <td class="title">参保人数</td>
                <td v-if="info.info">{{ info.info.参保人数 }}</td>
                <td class="title">参保人数所属年报</td>
                <td v-if="info.info">{{ info.info.参保人数所属年报 }}</td>
            </tr>
            <tr>
                <td class="title">纳税人资质</td>
                <td v-if="info.info">{{ info.info.纳税人资质 }}</td>
                <td class="title">最新年报营业收入</td>
                <td v-if="info.info">{{ info.info.最新年报营业收入 }}</td>
            </tr>
            <tr>
                <td class="title">营业期限</td>
                <td v-if="info.info">{{ info.info.营业期限 }}</td>
                <td class="title">国标行业门类</td>
                <td v-if="info.info">{{ info.info.国标行业门类 }}</td>
            </tr>
            <tr>
                <td class="title">国标行业大类</td>
                <td v-if="info.info">{{ info.info.国标行业大类 }}</td>
                <td class="title">国标行业中类</td>
                <td v-if="info.info">{{ info.info.国标行业中类 }}</td>
            </tr>
            <tr>
                <td class="title">国标行业小类</td>
                <td v-if="info.info">{{ info.info.国标行业小类 }}</td>
                <td class="title">企查查行业门类</td>
                <td v-if="info.info">{{ info.info.企查查行业门类 }}</td>
            </tr>
            <tr>
                <td class="title">企查分</td>
                <td v-if="info.info">{{ info.info.企查分}}</td>
                <td class="title">信用等级</td>
                <td v-if="info.info">{{ info.info.信用等级 }}</td>
            </tr>
            <tr>
                <td class="title">科创分</td>
                <td v-if="info.info">{{ info.info.科创分}}</td>
                <td class="title">科创等级</td>
                <td v-if="info.info">{{ info.info.科创等级 }}</td>
            </tr>
            <tr>
                <td class="title">企查查行业大类</td>
                <td v-if="info.info">{{ info.info.企查查行业大类 }}</td>
                <td class="title">企查查行业中类</td>
                <td v-if="info.info">{{ info.info.企查查行业中类 }}</td>
            </tr>
            <tr>
                <td class="title">企查查行业小类</td>
                <td v-if="info.info">{{ info.info.企查查行业小类 }}</td>
                <td class="title">企业规模</td>
                <td v-if="info.info">{{ info.info.企业规模 }}</td>
            </tr>
            <tr>
                <td class="title">曾用名</td>
                <td v-if="info.info">{{ info.info.曾用名 }}</td>
                <td class="title">英文名称</td>
                <td v-if="info.info">{{ info.info.英文名 }}</td>
            </tr>
            <tr>
                <td class="title">官网网址</td>
                <td v-if="info.info">{{ info.info.官网 }}</td>
                <td class="title">通信地址</td>
                <td v-if="info.info">{{ info.info.通信地址 }}</td>
            </tr>
            <!-- <tr>
                <td class="title">企业简介</td>
                <td colspan="3">{{ info.info.企业简介 }}</td>
            </tr> -->
            <tr>
                <td class="title">经营范围</td>
                <td colspan="3" v-if="info.info">{{ info.info.经营范围 }}</td>
            </tr>
        </table>
        <div style="text-align: center;" v-else>
            没有数据~~
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseInfo',
    props: {
        info: {
            type: Object
        }
    },
}
</script>

<style scoped>
.base-info .field-table {
    padding: 0.2rem 0.3rem;
}
.base-info .title {
    background-color: #fafafa;
    min-width: 2rem;
}
.base-info td {
    padding: 0.2rem 0.3rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/BaseInfo.vue